import React from 'react';
import { Drawer, Typography, Button, Space, Grid } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MarkDown from '../Markdown';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const FilePreviewDrawer = ({
  visible,
  onClose,
  file,
  onOpenFullFile
}) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  if (!file) return null;

  return (
    <Drawer
      title={
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center'
        }}>
          <div style={{ 
            fontSize: isMobile ? '16px' : 'inherit',
            wordBreak: 'break-word',
            maxWidth: isMobile ? '100%' : 'none'
          }}>
            {file.getDisplayFileName()}
          </div>
          {isMobile && (
            <div style={{ 
              alignSelf: 'flex-end',
              marginTop: '8px'
            }}>
              <Button
                type="primary"
                icon={<ExportOutlined />} 
                onClick={onOpenFullFile}
              >
                {t('session_files.open_file')}
              </Button>
            </div>
          )}
        </div>
      }
      placement="right"
      width={isMobile ? "100%" : "50%"}
      onClose={onClose}
      open={visible}
      extra={
        !isMobile ? (
          <Space>
            <Button
              type="primary"
              icon={<ExportOutlined />} 
              onClick={onOpenFullFile}
            >
              {t('session_files.open_file')}
            </Button>
          </Space>
        ) : null
      }
    >
      <div>
        {file.isValid() && (
        <div style={{ marginBottom: '16px' }}>
          <Text>{t('session_files.document_type')}: </Text>
            <Text strong>{file.getDocType()}</Text>
          </div>
        )}
        {file.isValid() && file.getRelevantDate() && (
          <div style={{ marginBottom: '16px' }}>
            <Text>{t('session_files.relevant_date')}: </Text>
            <Text strong>{file.getRelevantDate()}</Text>
          </div>
        )}
        <div>
          <Text style={{ display: 'block', marginBottom: '12px' }}>
            { file.isValid() ? t('session_files.preview') : t('session_files.preview_problem')}:
          </Text>
          <div style={{ 
            backgroundColor: '#fafafa', 
            padding: '16px', 
            borderRadius: '6px',
            border: '1px solid #e8e8e8',
            overflow: 'auto',
            color: '#333',
            fontSize: '15px'
          }}>
            {file.getDocTranscript() ? (
              <MarkDown content={file.getDocTranscript()} />
            ) : (
              <Text>{ file.getProblem() || t('files.no_preview_available')}</Text>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default FilePreviewDrawer; 